module.exports = __webpack_public_path__ + "media/mypage/images/collapsible-collapsed-2dd286d24ea506844af80066bb7355e2.png";